import * as React from "react";
import { RightOutlined } from "@ant-design/icons";
import { BrowserItemProps } from "../types";
import styles from "../BrowserServiceModal.module.scss";

export const BrowserColumnItem: React.FC<BrowserItemProps> = ({
  item,
  isActive,
  isClickable,
  isFocused,
  onClick,
}) => {
  const label = item.label || "";

  return (
    <button
      type="button"
      className={`${styles.item} ${isActive ? styles.itemActive : ""} ${
        isFocused ? styles.itemFocused : ""
      } ${!isClickable ? styles.itemDisabled : ""}`}
      onClick={isClickable ? onClick : undefined}
      disabled={!isClickable}
      role="option"
      aria-selected={isActive}
      data-browser-item
    >
      <span className={styles.itemLabel}>{label}</span>
      <span className={styles.itemArrow}>
        <RightOutlined style={{ fontSize: 12 }} />
      </span>
    </button>
  );
};
